// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__4N9Ls","header":"style__header__3hPxm","body":"style__body__ASSaw"};